/**
 * LaunchDarkly key: `dataSourceApiPreview`.
 *
 * When ON, the Data tab preview loads via the modelAPI preview endpoint
 * instead of downloading the full file from S3.
 *
 * Default true when the flag is undefined (local dev / flag not created).
 * Set false in production LaunchDarkly until rollout is complete.
 */
export const isDataSourceApiPreviewEnabled = (flags?: {
  dataSourceApiPreview?: boolean;
}): boolean => flags?.dataSourceApiPreview ?? true;

export default isDataSourceApiPreviewEnabled;
